/**
 * Sections - 3 block presentational cho Editorial Authority landing:
 * HowItWorks (S4) + TrustTierBlock (S8) + AudienceGrid (S6).
 * Data 100% tu copy deck (i18n/landing-editorial.ts) - khong hardcode copy.
 */
import { Link } from 'react-router-dom';
import type { LandingCopy } from '../../i18n/landing-editorial';
import { ArrowIcon } from './ArrowIcon';

export function HowItWorks({ copy }: { copy: LandingCopy }) {
  return (
    <section className="ed-section ed-section--paper" aria-labelledby="how-heading">
      <div className="ed-container">
        <p className="ed-eyebrow">{copy.how_eyebrow}</p>
        <h2 id="how-heading" className="ed-display-lg ed-h2--accent">{copy.how_heading}</h2>
        <div className="ed-grid-3" style={{ marginTop: 'var(--space-6)' }}>
          {copy.how_steps.map((s, i) => (
            <div className="ed-step" key={s.title}>
              <span className="ed-step__num">{String(i + 1).padStart(2, '0')}</span>
              <h3 className="ed-display-md">{s.title}</h3>
              <hr className="ed-card-rule" />
              <p>{s.body}</p>
            </div>
          ))}
        </div>
        {/* Phase 1B: video click-to-play dat day (spec S4) - placeholder layout san */}
      </div>
    </section>
  );
}

export function TrustTierBlock({ copy }: { copy: LandingCopy }) {
  return (
    <section className="ed-section ed-section--cream" aria-labelledby="trust-tier-heading">
      <div className="ed-container">
        <p className="ed-eyebrow">{copy.trust_tier_eyebrow}</p>
        <h2 id="trust-tier-heading" className="ed-display-lg">{copy.trust_tier_heading}</h2>
        <ul className="ed-grid-4" style={{ listStyle: 'none', margin: 'var(--space-6) 0 0', padding: 0 }}>
          {copy.trust_tier_points.map((p) => (
            <li className="ed-card" key={p}>{p}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}

// Phase 1B: audience media (AI-generated documentary, gemini-3-pro-image-preview).
// Thu tu khop copy.audiences: expat / individual / business / professional.
const AUDIENCE_IMG = [
  '/media/audience-expat.avif',
  '/media/audience-individual.avif',
  '/media/audience-business.avif',
  '/media/audience-professional.avif',
];

export function AudienceGrid({ copy }: { copy: LandingCopy }) {
  return (
    <section className="ed-section ed-section--cool" aria-labelledby="audience-heading">
      <div className="ed-container">
        <p className="ed-eyebrow">{copy.audience_eyebrow}</p>
        <h2 id="audience-heading" className="ed-display-lg">{copy.audience_heading}</h2>
        <div className="ed-grid-4" style={{ marginTop: 'var(--space-6)' }}>
          {copy.audiences.map((a, i) => (
            <Link to={a.to} className="ed-card ed-audience" key={a.title}>
              {AUDIENCE_IMG[i] ? (
                <div className="ed-audience__media">
                  <img src={AUDIENCE_IMG[i]} alt="" loading="lazy" decoding="async" width={800} height={500} />
                </div>
              ) : null}
              <div className="ed-audience__body">
                <h3 className="ed-display-md">{a.title}</h3>
                <hr className="ed-card-rule" />
                <p>{a.body}</p>
                <span className="ed-link-arrow">{a.cta} <ArrowIcon /></span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
